import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["cb", "isDate", "usageTracker", "updateCb"];
import _capitalize from 'hs-lodash/capitalize';
import _get from 'hs-lodash/get';
import _uniq from 'hs-lodash/uniq';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { ASSOCIATION_OBJECT_PROPERTIES } from '../../constants/associations';
import { singularTypeToPlural } from '../../constants/types';
import captureException from '../../utils/captureException';
import { SET_ACTIVE_OBJECT_ENTITY, UPDATE_ACTIVE_OBJECT } from './reducer';
export const getActiveObjectEntity = ({
  dispatch,
  apiWrapper
}, {
  objectType,
  cb,
  itemId,
  associationCardProperties,
  defaultSidebarProperties
}) => {
  const searchProperties = _uniq([...associationCardProperties, ...defaultSidebarProperties, ...ASSOCIATION_OBJECT_PROPERTIES[objectType]]);
  const data = {
    objectType,
    properties: searchProperties,
    objectId: itemId
  };
  apiWrapper.getObject(data).then(response => {
    dispatch({
      type: SET_ACTIVE_OBJECT_ENTITY,
      payload: response
    });
  }).catch(error => {
    captureException(error);
  }).finally(() => {
    if (typeof cb === 'function') cb();
  });
};
export const updateAssociatedObject = ({
  dispatch,
  apiWrapper
}, _ref) => {
  let {
      cb,
      isDate,
      usageTracker,
      updateCb
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  apiWrapper.updateAssociationObject(rest).then(response => {
    usageTracker.trackUsage(Object.assign({
      screen: SCREENS[`associated${_capitalize(rest.objectType)}`],
      type: rest.objectType
    }, ACTIONS.general.editObject));
    if (Object.entries(rest.data).every(([key, value]) => {
      // check if we update field with type date
      if (isDate) {
        return Number(new Date(response.properties[key])) === Number(new Date(value));
      }
      return response.properties[key] === value;
    })) {
      if (typeof cb === 'function') cb();
      dispatch({
        type: UPDATE_ACTIVE_OBJECT,
        payload: rest.data
      });
      if (typeof updateCb === 'function') updateCb({
        data: rest.data,
        objectId: rest.objectId,
        type: singularTypeToPlural[rest.objectType]
      });
    } else {
      if (typeof cb === 'function') cb('Field has not been updated');
    }
  }).catch(err => {
    captureException(err);
    // try to get responseJSON from error object, if we can`t, send hardcoded message
    // in case if server fails and can`t send proper response for error we won`t see responseJSON
    if (typeof cb === 'function') cb(_get(err, 'responseJSON.message', 'Value has not been updated, please try again later'));
  });
};